import * as React from 'react'
const LMDurationHour = () => (
  <svg
    width={30}
    height={34}
    viewBox="0 0 9.2466021 9.2127733"
    fill="currentColor"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1">
      <marker
        style={{
          overflow: "visible",
        }}
        id="ArrowWide"
        refX={0}
        refY={0}
        orient="auto-start-reverse"
        markerWidth={0.60000002}
        markerHeight={0.60000002}
        viewBox="0 0 1 1"
        preserveAspectRatio="xMidYMid"
      >
        <path
          style={{
            fill: "none",
            stroke: "context-stroke",
            strokeWidth: 1,
            strokeLinecap: "butt",
          }}
          d="M 3,-3 0,0 3,3"
          transform="rotate(180,0.125,0)"
          id="path1"
        />
      </marker>
    </defs>
    <g id="layer1" transform="translate(-83.586095,-145.01339)">
      <rect
        style={{
          display: "none",
          fill: "#280b0b",
          stroke: "#ffffff",
          strokeWidth: 0.529167,
          strokeLinejoin: "round",
        }}
        id="rect9"
        width={209.38908}
        height={297.40347}
        x={-0.35489929}
        y={-12.06649}
      />
      <g
        id="g128"
        transform="matrix(0.83899377,0,0,0.83899377,13.457882,24.274023)"
      >
        <ellipse
          style={{
            fill: "none",
            fillOpacity: 1,
            stroke: "var(--primary)",
            strokeWidth: 0.332313,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          id="path62"
          cx={89.144485}
          cy={149.80997}
          rx={4.0690899}
          ry={4.3399291}
        />
        <ellipse
          style={{
            fill: "none",
            fillOpacity: 1,
            stroke: "var(--accent)",
            strokeWidth: 0.686811,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          id="ellipse62"
          cx={89.144485}
          cy={149.80997}
          rx={4.0690899}
          ry={4.3399291}
        />
        <path
          id="ellipse63"
          style={{
            fill: "none",
            fillOpacity: 1,
            stroke: "var(--primary)",
            strokeWidth: 0.436141,
            strokeLinecap: "butt",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            markerEnd: "url(#ArrowWide)",
          }}
          d="m 88.965185,144.12766 c -2.874202,0.10304 -5.155771,2.61506 -5.161019,5.68229 -5.8e-5,3.14569 2.390771,5.69583 5.340134,5.69602 2.949505,5e-5 5.340563,-2.55017 5.340503,-5.69602 -5.6e-4,-1.35286 -0.452457,-2.66137 -1.274964,-3.69125"
        />
        <circle
          style={{
            fill: "var(--primary)",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 2.92845,
            strokeLinecap: "butt",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          id="path64"
          cx={89.859283}
          cy={144.12526}
          r={0.21552035}
        />
        <path
          id="rect64"
          style={{
            fill: "var(--primary)",
            strokeWidth: 1.3288,
            strokeLinejoin: "round",
          }}
          d="m -82.602191,-7.2696018 h 0.442909 a 0.76579846,0.76579846 45 0 1 0.765798,0.7657985 v 2.4174129 a 0.76579846,0.76579846 135 0 1 -0.765798,0.7657985 h -0.442909 a 0.76579846,0.76579846 45 0 1 -0.765798,-0.7657985 v -2.4174129 a 0.76579846,0.76579846 135 0 1 0.765798,-0.7657985 z"
          transform="matrix(0.25008459,0,0,0.19241308,109.74659,147.65316)"
        />
        <path
          id="path65"
          style={{
            fill: "var(--primary)",
            strokeWidth: 1.3288,
            strokeLinejoin: "round",
          }}
          d="m -82.602191,-7.2696018 h 0.442909 a 0.76579846,0.76579846 45 0 1 0.765798,0.7657985 v 2.4174129 a 0.76579846,0.76579846 135 0 1 -0.765798,0.7657985 h -0.442909 a 0.76579846,0.76579846 45 0 1 -0.765798,-0.7657985 v -2.4174129 a 0.76579846,0.76579846 135 0 1 0.765798,-0.7657985 z"
          transform="matrix(0.25008459,0,0,0.19241308,109.74659,153.78941)"
        />
        <path
          id="path66"
          style={{
            fill: "var(--primary)",
            strokeWidth: 1.3288,
            strokeLinejoin: "round",
          }}
          d="m -82.602191,-7.2696018 h 0.442909 a 0.76579846,0.76579846 45 0 1 0.765798,0.7657985 v 2.4174129 a 0.76579846,0.76579846 135 0 1 -0.765798,0.7657985 h -0.442909 a 0.76579846,0.76579846 45 0 1 -0.765798,-0.7657985 v -2.4174129 a 0.76579846,0.76579846 135 0 1 0.765798,-0.7657985 z"
          transform="matrix(0,-0.25008459,0.19241308,0,87.044251,129.09009)"
        />
        <path
          id="path68"
          style={{
            fill: "var(--primary)",
            strokeWidth: 1.3288,
            strokeLinejoin: "round",
          }}
          d="m -82.602191,-7.2696018 h 0.442909 a 0.76579846,0.76579846 45 0 1 0.765798,0.7657985 v 2.4174129 a 0.76579846,0.76579846 135 0 1 -0.765798,0.7657985 h -0.442909 a 0.76579846,0.76579846 45 0 1 -0.765798,-0.7657985 v -2.4174129 a 0.76579846,0.76579846 135 0 1 0.765798,-0.7657985 z"
          transform="matrix(0,-0.25008459,0.19241308,0,93.221249,129.09009)"
        />
        <path
          id="path70"
          style={{
            fill: "var(--foreground)",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.332313,
            strokeLinecap: "butt",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 89.1443,148.95593 a 0.71479941,0.73616019 0 0 0 -0.714495,0.73645 0.71479941,0.73616019 0 0 0 0.714495,0.73605 0.71479941,0.73616019 0 0 0 0.71489,-0.73605 0.71479941,0.73616019 0 0 0 -0.71489,-0.73645 z m 0,0.48207 a 0.24689652,0.25427465 0 0 1 0.246921,0.25438 0.24689652,0.25427465 0 0 1 -0.246921,0.25397 0.24689652,0.25427465 0 0 1 -0.246525,-0.25397 0.24689652,0.25427465 0 0 1 0.246525,-0.25438 z"
        />
        <path
          id="path71"
          style={{
            fill: "none",
            fillOpacity: 1,
            stroke: "var(--foreground)",
            strokeWidth: 0.332313,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="m 87.689042,148.30022 1.12133,1.07233 c 0.09047,-0.0765 0.21,-0.11921 0.334326,-0.11953 0.121467,1.5e-4 0.238521,0.0408 0.328442,0.11405 l 1.847571,-1.82564"
        />
      </g>
    </g>
  </svg>
)

export default LMDurationHour
